import { EnumServiceType } from './Generated';
import type { SelectOption } from '@synqo/frontend-component-library';

export const getEnumServiceTypeLabel = (value: EnumServiceType) => {
    switch (value) {
        case EnumServiceType.Material:
            return 'Material';
        case EnumServiceType.Service:
            return 'Dienstleistung';
        case EnumServiceType.Textservice:
            return 'Text';
        default:
            return 'Nicht definiert';
    }
};

export const serviceTypeOptions: SelectOption<EnumServiceType>[] = [
    {
        name: 'material',
        label: getEnumServiceTypeLabel(EnumServiceType.Material),
        value: EnumServiceType.Material,
    },
    {
        name: 'service',
        label: getEnumServiceTypeLabel(EnumServiceType.Service),
        value: EnumServiceType.Service,
    },
    {
        name: 'text',
        label: getEnumServiceTypeLabel(EnumServiceType.Textservice),
        value: EnumServiceType.Textservice,
    },
];
